import { render } from "./IntegratedDeviceText.vue?vue&type=template&id=e2324410&scoped=true"
import script from "./IntegratedDeviceText.vue?vue&type=script&lang=js"
export * from "./IntegratedDeviceText.vue?vue&type=script&lang=js"

import "./IntegratedDeviceText.vue?vue&type=style&index=0&id=e2324410&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2324410"]])

export default __exports__